<template>
  <v-sheet v-if="showInstructions" elevation="4" class="pa-4">
    <h3 class="text-h5">Annotation instructions</h3>
    <div class="body-1">
      <!-- 1 -->
      <v-list-item class="pl-2">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-numeric-1-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >Select an annotation class from the toolbox in the top left part of
            the screen</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <!-- 2 -->
      <v-list-item class="pl-2">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-numeric-2-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >Click on the WSI to start drawing</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <!-- A -->
      <v-list-item class="ml-4 pl-2">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-alpha-a-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >For circular shape annotations drag the mouse cursor to create a
            circle, then click on the WSI to finish</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <!-- B -->
      <v-list-item class="ml-4 pl-2">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-alpha-b-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >For polygon shape annotations click multiple times in different
            points of the WSI to create a vertix, then click again on the first
            vertix to finish</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <!-- 3 -->
      <v-list-item class="pl-2">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-numeric-3-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >In the new annotation window decide to store or discard the drawn
            annotation</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: {
    showInstructions: Boolean
  }
};
</script>

<style scoped></style>
